function ev_gameend(){
    var obj=$(".placeEventBack.gameend"),i=0;
    _eventTimeHandler.add(function(){
        i++;
        i=i%360;
        obj.cssrotate(i);
    },50);
}